import { useEffect, useState } from "react";
import { api, errMsg, STATUS_META } from "@/lib/api";
import { Link } from "react-router-dom";
import { UsersThree, CheckCircle, XCircle, Sun, FirstAidKit, Bandaids, Coffee, Bed, Question } from "@phosphor-icons/react";

const CARDS = [
  { key: "active_employees", label: "Dipendenti attivi", icon: UsersThree, accent: "text-primary" },
  { key: "PRESENTE", label: "Presenti oggi", icon: CheckCircle, accent: "text-emerald-600 dark:text-emerald-400" },
  { key: "ASSENTE", label: "Assenti oggi", icon: XCircle, accent: "text-rose-600 dark:text-rose-400" },
  { key: "FERIE", label: "Ferie oggi", icon: Sun, accent: "text-amber-600 dark:text-amber-400" },
  { key: "MALATTIA", label: "Malattia oggi", icon: FirstAidKit, accent: "text-purple-600 dark:text-purple-400" },
  { key: "INFORTUNIO", label: "Infortuni oggi", icon: Bandaids, accent: "text-orange-600 dark:text-orange-400" },
  { key: "PERMESSO", label: "Permessi oggi", icon: Coffee, accent: "text-sky-600 dark:text-sky-400" },
  { key: "RIPOSO", label: "Riposo oggi", icon: Bed, accent: "text-slate-500" },
  { key: "not_registered", label: "Non registrati", icon: Question, accent: "text-muted-foreground" },
];

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/dashboard").then((r) => setData(r.data)).catch((e) => setErr(errMsg(e)));
  }, []);

  const val = (k) => {
    if (!data) return "—";
    if (k === "active_employees") return data.active_employees;
    if (k === "not_registered") return data.not_registered;
    return data.today?.[k] ?? 0;
  };

  return (
    <div data-testid="dashboard-page" className="space-y-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-head font-bold tracking-tight">Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Situazione di oggi {data ? new Date(data.date).toLocaleDateString("it-IT") : ""} · {data?.total_employees ?? "—"} dipendenti in anagrafica
        </p>
      </div>

      {err && <div className="rounded-sm border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive">{err}</div>}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={`stat-${c.key}`} className="rounded-sm border border-border bg-card p-3.5">
            <div className="flex items-start justify-between">
              <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{c.label}</div>
              <c.icon size={17} weight="bold" className={c.accent} />
            </div>
            <div className="mt-2 text-3xl font-head font-bold tabular-nums">{val(c.key)}</div>
          </div>
        ))}
      </div>

      <div className="rounded-sm border border-border bg-card">
        <div className="border-b border-border px-4 py-3 flex items-center justify-between">
          <h2 className="font-head font-semibold text-base">Riepilogo mese corrente {data?.month_label ?? ""}</h2>
          <Link to="/presenze" className="text-xs font-semibold text-primary hover:underline" data-testid="dash-goto-calendar">
            Apri calendario →
          </Link>
        </div>
        <div className="p-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {Object.keys(STATUS_META).map((s) => (
            <div key={s} data-testid={`month-${s}`} className="rounded-sm border border-border p-3">
              <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
                <span className={`h-2 w-2 rounded-full ${STATUS_META[s].dot}`} /> {s}
              </div>
              <div className="mt-1.5 text-xl font-head font-bold tabular-nums">{data?.month?.[s] ?? "—"}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
